function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 0 0"
    }, props, {
        children: /*#__PURE__*/ _jsx("defs", {
            children: /*#__PURE__*/ _jsxs("linearGradient", {
                id: "paint0_linear_198_15990",
                x1: "11.7376",
                y1: "0.523009",
                x2: "20.2792",
                y2: "31.5382",
                gradientUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        stopColor: "#D8A62E"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0.2765",
                        stopColor: "#FBCA02"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0.5084",
                        stopColor: "#F6F583"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "0.757",
                        stopColor: "#FBCA02"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: "1",
                        stopColor: "#C69752"
                    })
                ]
            })
        })
    }));
};
export default Icon;
